import { Injectable } from '@angular/core';
import { UserInfoRequestModel } from '../models/request/userInfo-request';
import { BaseService } from './base.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ResultOfT } from '../models/response/result';
import { ClientCredentialsModel, UserFileUploadResponseModel, UserInfoResponseModel } from '../models/response/userInfo-response';
import { WebStorageService } from './web-storage.service';
import { Router } from '@angular/router';
import { ForgotPasswordModel, ResetPasswordModel, ChangePasswordModel } from '../models/response/forgot-password';
import { MunicipalityRequestModel } from '../models/request/municipality-request';
import { MunicipalityResponseModel } from '../models/response/municipality-response';
import { Observable, Subject } from 'rxjs';
import { AccessTokenResponseModel } from '../models/response/access-token-response';
import { UserPermissionRequestModel } from '../models/request/user-permission-request';
import { UserPermissionResponseModel } from '../models/response/user-permission-response';
import { PermissionByDocTypeRequestModel } from '../models/request/document-type-request';
import { CustomerSubscriptionRequestModel, GetCustomerSubscriptionsRequestModel } from '../models/request/customer-subscription-request';
import { CustomerSubscriptionResponseModel } from '../models/response/customer-subscription-response';
import { GetBatchUsageTrackingRequestModel } from '../models/request/batch-usage-tracking-request';
import { BatchUsageTrackingResponseModel } from '../models/response/batch-usage-tracking-response';
import { PagedResult } from '../models/response/result';
import { CompanyResponseModel } from '../models/response/company-response';

@Injectable({
  providedIn: 'root'
})
export class UserService extends BaseService {

  constructor(httpService: HttpClient, private webStorageService: WebStorageService,
    private router: Router) {
    super(httpService);
  }

  signIn(reqModel: UserInfoRequestModel) {
    return this.post<ResultOfT<UserInfoResponseModel>>('User/SignIn', reqModel);
  }

  signIn1(username: string, password: string) {
    const userData = 'username=' + username + '&password=' + password + '&grant_type=password';

    return this.post<ResultOfT<AccessTokenResponseModel>>('token', userData, new HttpHeaders(
      {
        'Content-Type': 'application/x-www-form-urlencoded',
      }));
  }

  signOut(redirectUrl: string = null) {
    this.webStorageService.deleteCurrentUserToken();
    this.router.navigate(['/login']);

    //this.onSignInOut.next(Constants.userType.none);
  }

  forgotPassword(reqModel: ForgotPasswordModel) {
    return this.post<ResultOfT<any>>('User/ForgotPassword', reqModel);
  }

  authenticateForgotPasswordRequest(reqModel: ForgotPasswordModel) {
    return this.post<ResultOfT<UserInfoResponseModel>>('User/AuthenticateForgotPasswordRequest', reqModel);
  }

  resetPassword(reqModel: ResetPasswordModel) {
    return this.post<ResultOfT<any>>('User/ResetPassword', reqModel);
  }

  updateProfile(reqModel: UserInfoRequestModel) {
    return this.post<ResultOfT<any>>('User/UpdateProfile', reqModel);
  }

  ChangePassword(reqModel: ChangePasswordModel) {
    return this.post<ResultOfT<boolean>>('User/ChangePassword', reqModel);
  }

  addNewCustomer(reqModel: MunicipalityRequestModel) {
    return this.post<ResultOfT<MunicipalityResponseModel>>('User/AddNewCustomer', reqModel);
  }

  getAllUsers(companyId: number) {
    return this.get<ResultOfT<UserInfoResponseModel[]>>('User/GetAllUser/' + companyId);
  }

  getUsers(userId: number) {
    return this.get<ResultOfT<UserInfoResponseModel>>('User/GetUser/' + userId);
  }

  saveUser(reqModel: UserInfoRequestModel) {
    return this.post<ResultOfT<boolean>>('User/AddUser', reqModel);
  }
  updateUser(reqModel: UserInfoRequestModel) {
    return this.post<ResultOfT<boolean>>('User/UpdateUser', reqModel);
  }

  deleteUser(userId: number, modifiedBy: number) {
    return this.get<ResultOfT<boolean>>('User/DeleteUser/' + userId + '/' + modifiedBy);
  }
  // deleteUser(userId: number) {
  //   return this.get<ResultOfT<boolean>>('User/DeleteUser/' + userId);
  // }

  addUpdateUserPermission(reqModel: UserPermissionRequestModel) {
    return this.post<ResultOfT<boolean>>('User/AddUpdateUserPermissions', reqModel);
  }

  sendEmailOnNewUser(reqModel: UserInfoRequestModel) {
    return this.post<ResultOfT<boolean>>('User/SendEmailNewUser', reqModel);
  }

  getUserpermissions(userId: number) {
    return this.get<ResultOfT<UserPermissionResponseModel>>('User/GetUserPermissions/' + userId);
  }

  // Start: New work flow
  getUserForGroupCreation(companyId: number) {
    return this.get<ResultOfT<UserInfoResponseModel[]>>('User/GetUserForGroupCreation/' + companyId);
  }

  getUsersForAssignUserPermission(reqModel: PermissionByDocTypeRequestModel) {
    return this.post<ResultOfT<UserInfoResponseModel[]>>('User/GetUsersForAssignUserPermission', reqModel);
  }

  resendUserPasswordResetLink(userId: number, modifiedBy: number) {
    return this.post<ResultOfT<any>>('User/ResendUserPasswordResetLink/' + userId + '/' + modifiedBy, null);
  }

  GetAllInceptionAdmins(searchText: string) {
    return this.get<ResultOfT<UserInfoResponseModel[]>>('User/GetAllInceptionAdmins/' + searchText);
  }

  UploadUserList(data: FormData) {
    return this.post<ResultOfT<UserFileUploadResponseModel>>('User/UploadUserList', data);
  }

  ResendUserPasswordResetLinkByCompanyId(companyId: number, modifiedBy: number) {
    return this.post<ResultOfT<any>>('User/ResendUserPasswordResetLinkByCompanyId/' + companyId + '/' + modifiedBy, null);
  }

  DownloadUserCSVTemplate() {
    return this.downloadBlobFile('User/DownloadUserCsvTemplate', null);
  }

  signOutWithLog(userId: number, companyId: number, userName: string, role: string) {
    return this.get<any>('User/SignOut'+ '/' + userId + '/' + companyId + '/' + userName +  '/' + role);
  }

  GetAllCompanyAdmins() {
    return this.get<ResultOfT<CompanyResponseModel[]>>('User/GetAllCompany');
  }

  createUpdateCustomerSubscription(reqModel: CustomerSubscriptionRequestModel) {
    return this.post<ResultOfT<any>>('User/CreateUpdateCustomerSubscription', reqModel);
  }

  getCustomerSubscriptions(reqModel: GetCustomerSubscriptionsRequestModel) {
    return this.post<ResultOfT<PagedResult<CustomerSubscriptionResponseModel>>>('User/GetCustomerSubscriptions', reqModel);
  }

  getBatchUsageTrackingByCustomerId(reqModel: GetBatchUsageTrackingRequestModel) {
    return this.post<ResultOfT<PagedResult<BatchUsageTrackingResponseModel>>>('User/GetBatchUsageTrackingByCustomerId', reqModel);
  }

  getAllBatchUsageTracking(reqModel: GetBatchUsageTrackingRequestModel) {
    return this.post<ResultOfT<PagedResult<BatchUsageTrackingResponseModel>>>('User/GetAllBatchUsageTracking', reqModel);
  }
}
